import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const InstructorsSection = () => {
  const { t } = useLanguage();

  const instructors = [
    {
      id: 1,
      name: 'Dr. Nawwaf Alshibli',
      role: t('masculineEnergyMaster'),
      description: t('nawwafDesc'),
      image: 'https://customer-assets.emergentagent.com/job_sacred-union-11/artifacts/66bydddn_1.png'
    },
    {
      id: 2,
      name: 'Inanna Nolan',
      role: t('feminineEnergyMaster'),
      description: t('inanaDesc'),
      image: 'https://customer-assets.emergentagent.com/job_sacred-union-11/artifacts/39hkv75y_2.png'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('meetYourGuides')}</h2>
          <p className="text-gray-400 text-lg">{t('guidesDesc')}</p>
        </div>

        {/* Instructors with Circular Glowing Profiles */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-24 mb-16">
          {instructors.map((instructor) => (
            <div key={instructor.id} className="flex flex-col items-center text-center max-w-sm">
              {/* Circular Profile with Glowing Edge */}
              <div 
                className="relative w-48 h-48 md:w-56 md:h-56 rounded-full mb-6"
                style={{
                  boxShadow: '0 0 40px rgba(212, 163, 58, 0.5), 0 0 80px rgba(212, 163, 58, 0.3), 0 0 120px rgba(212, 163, 58, 0.2)',
                }}
              >
                {/* Glowing border ring */}
                <div 
                  className="absolute inset-0 rounded-full"
                  style={{
                    border: '4px solid #d4a33a',
                    boxShadow: 'inset 0 0 20px rgba(212, 163, 58, 0.3)',
                  }}
                />
                {/* Second glow ring */}
                <div 
                  className="absolute -inset-2 rounded-full pointer-events-none"
                  style={{
                    border: '2px solid rgba(212, 163, 58, 0.3)',
                  }}
                />
                {/* Third outer glow ring */}
                <div 
                  className="absolute -inset-4 rounded-full pointer-events-none"
                  style={{
                    border: '1px solid rgba(212, 163, 58, 0.15)',
                  }}
                />
                {/* Image */}
                <img
                  src={instructor.image}
                  alt={instructor.name}
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              {/* Name and Role */}
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
                {instructor.name}
              </h3>
              <p className="text-[#d4a33a] font-medium mb-4">{instructor.role}</p>
              <p className="text-gray-400 leading-relaxed text-sm">
                {instructor.description}
              </p>
            </div>
          ))}
        </div>

        {/* Combined Section with both instructors */}
        <div className="bg-gradient-to-r from-[#2a3142] to-[#1f2535] rounded-2xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex -space-x-4">
              {instructors.map((instructor) => (
                <div
                  key={instructor.id}
                  className="relative w-20 h-20 md:w-24 md:h-24 rounded-full"
                  style={{
                    boxShadow: '0 0 20px rgba(212, 163, 58, 0.4)',
                  }}
                >
                  <div 
                    className="absolute inset-0 rounded-full"
                    style={{
                      border: '3px solid #d4a33a',
                    }}
                  />
                  <img
                    src={instructor.image}
                    alt={instructor.name}
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
              ))}
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2">{t('energyHealingCourse')}</h3>
              <p className="text-gray-400">
                {t('togetherDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstructorsSection;
